import { Box, Button, Typography, styled, useTheme } from "@mui/material";

import BookmarkCoin from "components/BookmarkCoin";
import DestinationsMenu from "./DestinationsMenu";
import React from "react";
import { TransferData } from "assets/Icon";

function TradeHead({
  coinMarketDetails,
  setShowMarketDrawer,
  destinations,
  hideActions = false,
  navigationPath,
}) {
  const theme = useTheme();

  return (
    <Box display="flex" alignItems="center" justifyContent="space-between">
      <Box display="flex">
        {hideActions ? (
          <Box display="flex" alignItems="center" py={1.5} px={1}>
            <Typography color="text.main" variant="h3" component="span">
              {coinMarketDetails?.coinSourceName}{" "}
            </Typography>{" "}
            <Typography color="text.main" component="small" fontWeight={300}>
              /{coinMarketDetails?.coinDestinationName}
            </Typography>
          </Box>
        ) : (
          <ButtonStyle
            variant="text"
            color="text"
            onClick={() => setShowMarketDrawer(true)}
          >
            <TransferData color={theme.palette.text.main} />
            <Typography variant="h3" component="span">
              {coinMarketDetails?.coinSourceName}{" "}
            </Typography>{" "}
            <Typography component="small" fontWeight={300}>
              /{coinMarketDetails?.coinDestinationName}
            </Typography>
          </ButtonStyle>
        )}

        {!hideActions && (
          <DestinationsMenu
            destinations={destinations}
            navigationPath={navigationPath}
          />
        )}
      </Box>

      <BookmarkCoin size="22px" data={coinMarketDetails} />
    </Box>
  );
}

const ButtonStyle = styled(Button)(({ theme }) => ({
  svg: {
    fontSize: "24px",
    marginRight: "6px",
  },
}));

export default TradeHead;
